import { render, staticRenderFns } from "./veJkyCategory.vue?vue&type=template&id=7aaf29d6&scoped=true"
import script from "./veJkyCategory.vue?vue&type=script&lang=js"
export * from "./veJkyCategory.vue?vue&type=script&lang=js"
import style0 from "./veJkyCategory.vue?vue&type=style&index=0&id=7aaf29d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaf29d6",
  null
  
)

export default component.exports